module.exports = __webpack_public_path__ + "img/menu_voya.898d5690.svg";